import { http } from "./client";

export const fetchPdsEntries = (ApplicationID) => http.get('Applications/PDS',{params: {ApplicationID}});
export const fetchPdsEntry = (ApplicationID,PDSId) => http.get('Applications/PDS/get',{params: {ApplicationID,PDSId}});
export const PdsAdd = (payload) => http.post('Applications/PDS/add',payload);
export const PdsUpdate = (payload) => http.patch('Applications/PDS/update',payload);
export const PdsDelete = (payload) => http.delete('Applications/PDS/delete',payload)
